<template>
  <div>
    <div id="create-form__new-section-popup"
        class="w-[775px] mfp-hide max-w-[90vw] rounded-[8px] md:py-12 md:px-16 p-6 mx-auto bg-white absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
        <button class="mfp-close size-10">
          <svg class="rotate-45 pointer-events-none size-6 icon icon-plus text-brand-medium-gray" aria-hidden="true"><use xlink:href="#icon-plus"></use></svg>
        </button>
        <p class="mb-3 text-center hdg text-brand-wicked">
          Add New Section
        </p>
        <p class="mb-4 text-center text-brand-medium-gray paragraph-default">
          Add your section label and any directions you'd like to feature.
        </p>

        <div class="form">
          <input type="hidden" name="create-form-section-id" id="create-form-section-id" value="<?= wp_rand() ?>">

          <label for="create-form-section-name">Section Name</label>
          <input v-model="name" type="text" name="create-form-section-name" id="create-form-section-name" value="">
          <p class="field_description">e.g. "Face & Neck"</p>

          <label for="create-form-section-directions">Section Directions</label>
          <input v-model="directions" type="text" name="create-form-section-directions" id="create-form-section-directions" value="">
          <p class="field_description">e.g. "Select any concerns from this area. If you have none skip this section."</p>

          <input
            :class="{ 'border border-form-error' : error, '' : !error }"
            id="submit-new-section" class="w-full mt-4 form-submit btn-primary" type="submit" name="add_section" value="Continue">

          <div v-if="error">{{ error }}</div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import axios from 'axios';

const props = defineProps(['sectionName', 'sectionDirections', 'errorMessage']);

const name = ref(props.sectionName);
const directions = ref(props.sectionDirections);
const error = ref(props.errorMessage);



</script>

